import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-import-upload.module.scss";
import VelavuButton from "../../../../elements/velavu-button";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import DocumentUploadField from "../../../../elements/document-upload-field";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import { fileToPlaceableImage } from "../../../../helper/image-render-helper";
import UserImageData from "../../../../data/user-image-data";

export interface SiteModalFileUploadProps {
	onBack?: VoidFunction;
	onClose?: VoidFunction;
	onUpload?: (image: UserImageData) => void;
}

export default function FloorCreateImportUpload(
	props: SiteModalFileUploadProps,
) {
	const { t } = useTranslation();
	const propsOnUpload = props.onUpload;
	const handleFile = useCallback(
		async (file: File) => {
			try {
				const placeableImage = await fileToPlaceableImage(file);
				propsOnUpload?.(placeableImage);
			} catch (error) {
				alert(t("dashboard.floor_create.upload_failed"));
				console.warn("Failed to load image", error);
			}
		},
		[propsOnUpload, t],
	);

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.upload_header")}
				onClose={props.onClose}
			/>

			<div className={styles.container}>
				<VelavuNotice type="info">
					{t("dashboard.floor_create.import_notice")}
				</VelavuNotice>

				<DocumentUploadField
					className={styles.uploadButton}
					onReceive={handleFile}
				/>

				<div className={styles.buttonBar}>
					<VelavuButton
						className={styles.buttonBack}
						label={t("common.back")}
						variant="outlined"
						fullWidth
						onClick={props.onBack}
					/>
				</div>
			</div>
		</PinnedList>
	);
}
